var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-auto flex flex-col justify-center items-center"},[_c('Todo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }